'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAsyncActionTypes = undefined;

var _asyncStatuses = require('../async-data/constants/asyncStatuses');

var _invariant = require('../lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _isActionType = require('../lib/isActionType');

var _isActionType2 = _interopRequireDefault(_isActionType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @description given a base action name, returns an
 * object actions for all async statuses. Intended
 * to be used with ./createAsyncAction.
 * @param {String} actionName a base action name
 * @returns {Object} request status action types
 *
 * @example <caption>Async actions for fetching a record</caption>
 * const THREAD_FETCH = createAsyncActionTypes('THREAD_FETCH');
 * // THREAD_FETCH === {
 * //   FAILED: 'THREAD_FETCH_FAILED',
 * //   SUCCEEDED: 'THREAD_FETCH_SUCCEEDED',
 * //   STARTED: 'THREAD_FETCH_STARTED',
 * // }
 */
var createAsyncActionTypes = exports.createAsyncActionTypes = function createAsyncActionTypes(actionName) {
  var _ref;

  (0, _invariant2.default)((0, _isActionType2.default)(actionName), 'createAsyncActionTypes requires a valid base actionName');

  return _ref = {}, _defineProperty(_ref, _asyncStatuses.FAILED, actionName + '_FAILED'), _defineProperty(_ref, _asyncStatuses.OUT_OF_SYNC, actionName + '_OUT_OF_SYNC'), _defineProperty(_ref, _asyncStatuses.STARTED, actionName + '_STARTED'), _defineProperty(_ref, _asyncStatuses.SUCCEEDED, actionName + '_SUCCEEDED'), _defineProperty(_ref, _asyncStatuses.UNINITIALIZED, actionName + '_UNINITIALIZED'), _ref;
};